import "./style.css"

export const SelectProhibited = () =>{
    return(
        <select className="select-prohibited font-size-4 font-weight-2 font-color-7" required>
            <option value="Entrada" >Entrada</option>
            <option value="Despesa">Despesa</option>
        </select>
    )
}